module.exports = __webpack_public_path__ + "img/p_knight4cf.ea08c496.jpg";